import { LoadingButton } from "@mui/lab";
import { Alert, Divider, Stack, TextField, Typography } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { AccountService, OtpType } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";

export default function UnFreezeAccountDialog() {
    const [otpCode, setOtpCode] = useState("");
    const [verificationCodeSent, setVerificationCodeSent] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [requestInProgress, setRequestInProgress] = useState(false);

    const sendVerificationCode = () => {
        setRequestInProgress(true);
        setError(null);
        AccountService.sendOtp("1", {
            otpType: OtpType.UN_FREEZE_ACCOUNT,
        })
            .then((r) => {
                setVerificationCodeSent(true);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const handleCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
        setOtpCode(event.target.value);
    };

    const applyUnFreeze = () => {
        setRequestInProgress(true);
        AccountService.unFreezeAccount("1", {
            otpCode: otpCode,
        })
            .then((r) => {
                window.location.reload();
            })
            .catch((e) => {
                setError("کد تایید وارد شده صحیح نیست");
                setVerificationCodeSent(false);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    return (
        <DialogContainer>
            <DialogHeader title="حارج شدن از حالت فریز" />

            <Stack sx={{ p: 2 }} spacing={2}>
                <Typography>
                    با خارج شدن از حالت فریز بازه زمانی که حساب کاربری شما فریز
                    شده بود به اشتراک شما بازگردانده خواهد شد.
                </Typography>

                <Divider />

                {error && <Alert severity="error">{error}</Alert>}

                {!verificationCodeSent && (
                    <LoadingButton
                        variant="contained"
                        loading={requestInProgress}
                        fullWidth
                        onClick={sendVerificationCode}
                    >
                        ارسال کد تایید
                    </LoadingButton>
                )}

                {verificationCodeSent && (
                    <>
                        <TextField
                            type="tel"
                            onChange={handleCodeChange}
                            autoComplete="one-time-code"
                            fullWidth
                            autoFocus
                            label="کد یکبار مصرف"
                        />

                        <LoadingButton
                            variant="contained"
                            loading={requestInProgress}
                            color="warning"
                            onClick={applyUnFreeze}
                        >
                            تایید خارج شدن از حالت فریز
                        </LoadingButton>
                    </>
                )}
            </Stack>
        </DialogContainer>
    );
}
